// Agent run events (GET /api/v1/agents/runs/{id}/events) folded into the run object the
// runs list renders. Pure, so the same reducer serves the live stream and its tests.

export const LIVE_RUN_STATUSES = new Set(["queued", "running", "awaiting_approval", "waiting"]);

const STATUS_FIELDS = ["error", "result", "pending_action"];

export function isTerminalRunEvent(event) {
  return Boolean(event && event.type === "run.status" && event.payload
    && !LIVE_RUN_STATUSES.has(event.payload.status));
}

/** The run after `event`: `run.status` sets status (+ error/result/pending_action when sent),
 * `step` upserts the step at its index. Unknown event types leave the run unchanged. */
export function applyRunEvent(run, event) {
  if (!run || !event || !event.payload) return run;
  if (event.type === "run.status") {
    const next = { ...run, status: event.payload.status };
    STATUS_FIELDS.forEach((field) => {
      if (field in event.payload) next[field] = event.payload[field];
    });
    if (next.status !== "awaiting_approval") next.pending_action = null;
    return next;
  }
  if (event.type === "step") {
    const { index, step } = event.payload;
    if (!Number.isInteger(index) || index < 0 || !step) return run;
    const steps = [...(run.steps || [])];
    steps[index] = step;
    return { ...run, steps };
  }
  if (typeof event.type === "string" && event.type.startsWith("team.")) {
    return { ...run, team_seq: Math.max(run.team_seq || 0, event.seq || 0) };
  }
  return run;
}
